import { useState } from "react";
import { Check, Copy, X } from "lucide-react";
import { useI18n } from "../lib/i18n";
import { accountMailLabel } from "./AccountMailStatus";

async function copyText(value) {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(value);
    return;
  }
  const field = document.createElement("textarea");
  field.value = value; field.style.position = "fixed"; field.style.opacity = "0";
  document.body.appendChild(field); field.select(); document.execCommand("copy"); field.remove();
}

export function absoluteCredentialLink(value, browserOrigin = window.location.origin) {
  const raw = String(value || "").trim();
  if (!raw || raw.startsWith("//")) return "";
  try {
    const absolute = new URL(raw);
    return ["http:", "https:"].includes(absolute.protocol) ? absolute.href : "";
  } catch {
    try {
      const base = new URL(browserOrigin);
      if (!["http:", "https:"].includes(base.protocol)) return "";
      return new URL(raw.startsWith("/") ? raw : `/${raw}`, base.origin).href;
    } catch {
      return "";
    }
  }
}

export default function CredentialLinkNotice({ status, link, onClose }) {
  const { t, lang } = useI18n();
  const [copied, setCopied] = useState(false);
  const message = accountMailLabel(status, lang) || (status === "sent" ? t("emailDeliverySent")
    : status === "unavailable" ? t("emailDeliveryUnavailable")
      : t("devLinkCreatedNoEmail"));
  const copyableLink = absoluteCredentialLink(link);
  return <div className="pc-card p-3 mb-4 text-sm flex items-center gap-3" data-testid="credential-delivery-notice" style={{ color: status === "unavailable" ? "var(--pc-score-poor)" : "var(--pc-cyan)" }}>
    <span className="min-w-0 flex-1">{message}</span>
    {copyableLink && <button type="button" className="pc-btn pc-btn-ghost inline-flex items-center gap-1.5 shrink-0" style={{ padding: "7px 10px", fontSize: 12 }} onClick={async () => { await copyText(copyableLink); setCopied(true); }} data-testid="copy-credential-link">{copied ? <Check size={14} /> : <Copy size={14} />}{t(copied ? "linkCopied" : "copyLink")}</button>}
    {onClose && <button type="button" className="pc-btn pc-btn-ghost shrink-0" style={{ padding: 6 }} onClick={onClose} aria-label={t("close")}><X size={14} /></button>}
  </div>;
}
